import { PrincipleBlock } from '../components/PrincipleBlock';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './FiveThingsSection.module.css';

const principles = [
  {
    body:
      'State-of-the-art AI cannot become another line on the list of things students with money can buy and students without cannot. Every Kudu student gets the same KAI, regardless of family income, regardless of the tier their classmates can afford outside class. Equitable access is not a feature we charge extra for. It is the design constraint that everything else fits around.',
    number: '01',
    title: 'Equity comes first.',
  },
  {
    body:
      "An AI that can solve any homework problem is a worse education product than an AI that cannot. KAI is deliberately constrained to teach rather than perform. It will ask leading questions. It will give partial hints. It will tell a student they are close. It will not write the essay or solve the integral. The goal is the student's learning, not the convenience of the answer.",
    number: '02',
    title: 'Pedagogy outranks capability.',
  },
  {
    body:
      "Most AI hallucination problems disappear when the model is given accurate course context and can answer from the course's approved material. KAI is grounded in the actual textbook of the course it is deployed in. Faculty can see what KAI knows because faculty wrote or approved the source material. The result is an AI that is wrong less often and, when it is wrong, wrong about things faculty can correct.",
    number: '03',
    title: 'Course context, not the open internet.',
  },
  {
    body:
      'Anyone can write a privacy policy. KAI is structured so that even if we wanted to train on student data, we could not. Queries are anonymized at the routing layer before they reach a model provider, and the providers we use are contractually bound not to retain or train on what they receive. The architecture is the guarantee, not the marketing copy.',
    number: '04',
    title: 'Privacy by architecture, not by promise.',
  },
  {
    body:
      "The frontier model landscape changes every quarter. Today's best provider is tomorrow's also-ran. Kudu holds the relationships with multiple frontier model providers so institutions do not have to. KAI is model-agnostic by design. When a better model arrives, we route to it. Your campus gets frontier capability without signing frontier contracts.",
    number: '05',
    title: "Institutions shouldn't have to pick an AI vendor.",
  },
] as const;

export function FiveThingsSection() {
  return (
    <SectionWrapper
      background="navy"
      contentClassName={styles.content}
      data-testid="ai-section-five-things"
    >
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>OUR POSITION</p>
          <h2 className={styles.title}>
            Five things we believe AI in education has to get right.
          </h2>
          <p className={styles.subhead}>
            If a vendor&apos;s AI doesn&apos;t honor each of these, the
            institution is taking on risk the vendor isn&apos;t carrying. KAI is
            built to honor all five.
          </p>
        </div>

        <div className={styles.principles}>
          {principles.map((principle) => (
            <PrincipleBlock key={principle.number} {...principle} />
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
